var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgePlatinum(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icono / Medalla / Platino") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icono-/-Medalla-/-Platino",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "0 24 24 24 24 0 0 0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(5.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,19 C11,21.209 9.209,23 7,23 C4.791,23 3,21.209 3,19 C3,16.791 4.791,15 7,15 C9.209,15 11,16.791 11,19",
    id: "Fill-2",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4961,10.2881 L7.4961,13.7171 C7.1881,13.8921 6.8111,13.8921 6.5041,13.7171 L0.5041,10.2881 C0.1921,10.1101 0.0001,9.7781 0.0001,9.4201 L0.0001,1.0001 C0.0001,0.4471 0.4481,0.0001 1.0001,0.0001 L13.0001,0.0001 C13.5521,0.0001 14.0001,0.4471 14.0001,1.0001 L14.0001,9.4201 C14.0001,9.7781 13.8081,10.1101 13.4961,10.2881",
    id: "Fill-4",
    fill: "#917432"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.647,0.252 L0.129,9.907 C0.216,10.064 0.344,10.196 0.504,10.288 L6.504,13.717 C6.812,13.893 7.189,13.893 7.496,13.717 L13.496,10.288 C13.808,10.109 14,9.778 14,9.42 L14,1 C14,0.697 13.859,0.436 13.647,0.252",
    id: "Fill-6",
    fill: "#E3B750"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.1294,9.9072 C0.0464,9.7612 0.0004,9.5942 0.0004,9.4202 L0.0004,1.0002 C0.0004,0.6972 0.1414,0.4352 0.3534,0.2522 L7.0004,5.0002 L0.1294,9.9072 Z",
    id: "Fill-8",
    fill: "#C8A046"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgePlatinum);
export default __webpack_public_path__ + "static/media/badge-platinum.1ad19d7afbbe616c358a8ee7949bfaea.svg";
export { ForwardRef as ReactComponent };